/**
 * The product's mark: the app's own icon when it has one, else its initial on
 * the accent tile.
 *
 * One component, because the sign-in page, the staff shell and the client shell
 * all draw it — three copies of a mark are three places for it to drift.
 */

import { appConfig } from '../../config/app-config';
import { cn } from '../../lib/cn';

const SIZES = {
  sm: 'size-8 rounded-control text-sm',
  lg: 'size-11 rounded-card text-lg',
} as const;

export function BrandMark({
  size = 'sm',
  className,
}: {
  size?: keyof typeof SIZES;
  className?: string;
}) {
  const { appName, logoSrc } = appConfig();
  if (logoSrc) {
    // Decorative: the product name is always written beside it.
    return (
      <img
        src={logoSrc}
        alt=""
        aria-hidden
        className={cn('block shrink-0 object-contain', SIZES[size], className)}
      />
    );
  }
  return (
    <span
      className={cn(
        'flex shrink-0 items-center justify-center bg-accent font-bold text-accent-fg',
        SIZES[size],
        className,
      )}
    >
      {appName.charAt(0)}
    </span>
  );
}
